import Items from './Items';
import Pagination from './Pagination';
import Hero from './Detail/Hero';
import CustomHero from './CustomHero';
import List from './Detail/List';
import RecentPost from './Detail/RecentPost';

export { Items, Pagination, Hero, CustomHero, List, RecentPost };
